Vue.use(Vuex)
const store = new Vuex.Store({
    state: {},
    mutations: {},
    getters: {}
})